module.exports = __webpack_public_path__ + "static/media/urbangoo24.458b3ad0.webp";